module.exports = __webpack_public_path__ + "static/media/active-mic-icon-white.82a59406.svg";